import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Base } from '@fiverr-private/modal/src';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import listingsTracker from '../../../apps/listings/service/tracker';
import categoryTracker from '../../../apps/categories/service/tracker';
import ModalBody from './ModalBody';
import './index.scss';

const ExplanationVideo = ({
    hasVideoLink = false,
    subcat = {},
    isCategoryPage = false,
    src
}) => {

    const tracker = isCategoryPage ? categoryTracker : listingsTracker;

    const onOpen = () => {
        const { categoryName, title } = subcat;
        tracker.trackHowFiverrWorksVideo({ categoryName, subcategoryName: title });
    };

    const videoTag = hasVideoLink ? 'shared.explanation_video.title' : 'shared.how_fiverr_works';
    const playBtnClass = classNames('btn-play', { 'separated-video-link': hasVideoLink });

    return (
        <div className="explanation-video">
            {subcat.subtitle && <p>{subcat.subtitle}</p>}
            <Base name="explanation-video-modal"
                onOpen={onOpen}
                trigger={({ open }) => <button className={playBtnClass} onClick={open}><i className="fa fa-play-circle"/><span><I18n k={videoTag}/></span></button>}
                header=" ">
                {() => <ModalBody videoUrl={src}/>}
            </Base>
        </div>
    );
};

ExplanationVideo.propTypes = {
    subcat: PropTypes.object,
    src: PropTypes.string,
    hasVideoLink: PropTypes.bool,
    isCategoryPage: PropTypes.bool
};

export default ExplanationVideo;